import  { useState } from 'react';
import { InputGroup, Input, InputGroupAddon, InputGroupText, Pagination, PaginationItem, PaginationLink } from 'reactstrap';

import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import { useDebounce } from '../../hook/debounce';
import { useModalContext } from '../../contexts/ModalContext';
import Loader from '../Loader/buttonLoad';
import { useUserSlotHis } from '../modals/api/api';
import { Check, Eye } from 'lucide-react';
import { copyToClipboard } from '../../lib/copytoClipboard';
import { useToast } from '../../hook/usetoast';
import PropTypes from 'prop-types';

const SlotHistory = ({ slotNumber,clubName , back }) => {
    const navigate = useNavigate()

    const { search, setSearch } = useModalContext()
    const [uniqueId, setUniqueId] = useState(false)
    const toast = useToast()

    const searchText = useDebounce(search)
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const { data: SlotHistoryList, isLoading } = useUserSlotHis({
        page,
        size: rowsPerPage,
        searchText,
        slotNumber
    })

    const totalPages = SlotHistoryList?.count ? Math.ceil(SlotHistoryList.count / rowsPerPage) : 0;




    const handlePageChange = (newPage) => {

        const currentScrollY = window.scrollY;
        if (newPage >= 0 && newPage < totalPages) {
            setPage(newPage);


            window.requestAnimationFrame(() => {


                window.scrollTo(0, currentScrollY);
            });
        }
    };
    const copyUserId = async data => {
        setUniqueId(data)
        await copyToClipboard(data)
        toast.success("Slot ID is copied")
        setTimeout(() => {
            setUniqueId(false)
        }, 300);
    }
    return (
        <div>
            {isLoading && <Loader />}
            <div className="px-4 mb-3">
                <div className='row justify-content-between'>
                    <div className="col-md-6 mb-2 mb-md-0 text-center text-md-left">
                        <div className='d-inline-flex g-8 align-items-center'>
                            <span className='fs-18 fw-400 text-white-60'>Show</span>
                            <div className='form-group mb-0 formInputs gradientBg'>
                                <select className='form-control' onChange={(e) => {
                                    setRowsPerPage(Number(e.target.value));
                                    setPage(0);
                                }}>
                                    <option value="10">10</option>
                                    <option value="30">30</option>
                                    <option value="50">50</option>
                                </select>
                            </div>
                            <span className='fs-18 fw-400 text-white-60'>entries</span>
                        </div>
                    </div>
                    <div className='col-md-6'>
                        <div className='form-inline justify-content-md-end justify-content-center'>
                            <div className="formInputs form-group gradientBg">
                                <InputGroup>
                                    <InputGroupAddon addonType="prepend" tag='div'>
                                        <InputGroupText className='pl-0'>
                                            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M2.25 7.5C2.25 8.18944 2.3858 8.87213 2.64963 9.50909C2.91347 10.146 3.30018 10.7248 3.78769 11.2123C4.2752 11.6998 4.85395 12.0865 5.49091 12.3504C6.12787 12.6142 6.81056 12.75 7.5 12.75C8.18944 12.75 8.87213 12.6142 9.50909 12.3504C10.146 12.0865 10.7248 11.6998 11.2123 11.2123C11.6998 10.7248 12.0865 10.146 12.3504 9.50909C12.6142 8.87213 12.75 8.18944 12.75 7.5C12.75 6.81056 12.6142 6.12787 12.3504 5.49091C12.0865 4.85395 11.6998 4.2752 11.2123 3.78769C10.7248 3.30018 10.146 2.91347 9.50909 2.64963C8.87213 2.3858 8.18944 2.25 7.5 2.25C6.81056 2.25 6.12787 2.3858 5.49091 2.64963C4.85395 2.91347 4.2752 3.30018 3.78769 3.78769C3.30018 4.2752 2.91347 4.85395 2.64963 5.49091C2.3858 6.12787 2.25 6.81056 2.25 7.5Z" stroke="white" strokeOpacity="0.6" strokeLinecap="round" strokeLinejoin="round" />
                                                <path d="M15.75 15.75L11.25 11.25" stroke="white" strokeOpacity="0.6" strokeLinecap="round" strokeLinejoin="round" />
                                            </svg>
                                        </InputGroupText>
                                    </InputGroupAddon>
                                    <Input type='text' placeholder='Search' value={search} onChange={(e) => setSearch(e.target.value)} />
                                </InputGroup>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            <div className='table-responsive mb-3'>
                <table className='table myapptable table-hover table-borderless mb-0'>
                    <thead>
                        <tr>
                            <th className='text-center'>S.No</th>
                            <th className='text-center'>Slot ID</th>
                            <th className='text-center'>Slot</th>
                            <th className='text-center'>Date & Time</th>
                            <th className='text-right pr-4'>Action</th>
                        </tr>
                    </thead>
                    <tbody>

                        {
                            SlotHistoryList?.data?.length > 0 ? (
                                SlotHistoryList?.data?.map((v, i) => (
                                    <tr key={v?._id}>

                                        <td align='center'>{page * rowsPerPage + (i + 1)}</td>
                                        <td align='center'> {v?.slotId}
                                            {' '}  {uniqueId === v?.slotId ? <Check size={20} color="#FCD535" cursor="not-allowed" /> : <button className='btn btnEmpty' onClick={() => copyUserId(v?.slotId)}>
                                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M7 9.667C7 8.95967 7.28099 8.28131 7.78115 7.78115C8.28131 7.28099 8.95967 7 9.667 7H18.333C18.6832 7 19.03 7.06898 19.3536 7.20301C19.6772 7.33704 19.9712 7.53349 20.2189 7.78115C20.4665 8.0288 20.663 8.32281 20.797 8.64638C20.931 8.96996 21 9.31676 21 9.667V18.333C21 18.6832 20.931 19.03 20.797 19.3536C20.663 19.6772 20.4665 19.9712 20.2189 20.2189C19.9712 20.4665 19.6772 20.663 19.3536 20.797C19.03 20.931 18.6832 21 18.333 21H9.667C9.31676 21 8.96996 20.931 8.64638 20.797C8.32281 20.663 8.0288 20.4665 7.78115 20.2189C7.53349 19.9712 7.33704 19.6772 7.20301 19.3536C7.06898 19.03 7 18.6832 7 18.333V9.667Z" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                    <path d="M4.012 16.737C3.70534 16.5622 3.45027 16.3095 3.27258 16.0045C3.09488 15.6995 3.00085 15.353 3 15V5C3 3.9 3.9 3 5 3H15C15.75 3 16.158 3.385 16.5 4" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                </svg>
                                            </button>}
                                        </td>
                                        <td align='center'> {v?.slotCount}</td>

                                        <td align='center' > <span>{moment(v?.createdAt).format("DD/MM/YYYY | hh:mm A")}</span></td>
                                        <td className='text-right pr-4'>
                                            <button
                                                className="btn btn-secondary "
                                                onClick={() => navigate(`/reward-view/${v.slotId}`,{state:{state:clubName , back : back}})}
                                            >
                                                <Eye className='eye text-white' />
                                            </button>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="5" className="text-center">No data found</td>
                                </tr>
                            )
                        }

                    </tbody>
                </table>
            </div>
            <div className="px-4">
                <div className='row'>

                    <div className='col-lg-12'>
                        <Pagination aria-label="Page navigation" className='customPagination'>

                            <PaginationItem disabled={page === 0}>
                                <PaginationLink previous href="#" onClick={(e) => {e.preventDefault(); handlePageChange(page - 1)}} className='prevbtn'>
                                    <i className='bi bi-arrow-left align-bottom'></i> Previous
                                </PaginationLink>
                            </PaginationItem>
                            <span className='number'>
                                {totalPages > 6 && page > 3 && (
                                    <>
                                        <PaginationItem key={0} active={page === 0}>
                                            <PaginationLink href="#" onClick={(e) => {e.preventDefault(); handlePageChange(0)}}>
                                                1
                                            </PaginationLink>
                                        </PaginationItem>
                                        <PaginationItem disabled>
                                            <PaginationLink href="#">
                                                ...
                                            </PaginationLink>
                                        </PaginationItem>
                                    </>
                                )}

                                {/* Show pages near the current page */}
                                {Array.from({ length: totalPages }, (_, index) => {
                                    if (index === 1 || index === 2 || index === totalPages - 0 || (index >= page - 2 && index <= page + 2)) {
                                        return (
                                            <PaginationItem key={index} active={index === page}>
                                                <PaginationLink href="#" onClick={(e) => {e.preventDefault(); handlePageChange(index)}}>
                                                    {index + 1}
                                                </PaginationLink>
                                            </PaginationItem>
                                        );
                                    }
                                    return null;
                                })}

                                {totalPages > 6 && page < totalPages - 4 && (
                                    <>
                                        <PaginationItem disabled>
                                            <PaginationLink href="#">
                                                ...
                                            </PaginationLink>
                                        </PaginationItem>
                                        <PaginationItem key={totalPages - 1} active={page === totalPages - 1}>
                                            <PaginationLink href="#" onClick={(e) => { e.preventDefault(); handlePageChange(totalPages - 1)}}>
                                                {totalPages}
                                            </PaginationLink>
                                        </PaginationItem>
                                    </>
                                )}
                            </span>

                            <PaginationItem disabled={page === totalPages - 1}>
                                <PaginationLink next href="#" onClick={(e) => { e.preventDefault(); handlePageChange(page + 1)}} className='nextbtn'>
                                    Next <i className='bi bi-arrow-right align-bottom'></i>
                                </PaginationLink>
                            </PaginationItem>
                        </Pagination>
                    </div>
                </div>
            </div>
        </div>
    )
}
SlotHistory.propTypes = {
    slotNumber: PropTypes.any,
    clubName: PropTypes.any,
    back:PropTypes.any

}
export default SlotHistory;